module.exports = __webpack_public_path__ + "img/sweph.5b45eb18.gif";